import React, { FC, ReactNode, useEffect } from 'react';
import s from './index.scss';
import { useTranslation } from '@wix/wix-i18n-config';
import { Asset } from '@wix/ambassador-funnel-templates-gallery-v2-template/types';
import { modalShown, reportEditorClick } from '../../utils/bi';
import { CustomModal } from '../CustomModal';

interface ITemplateModalProps {
  isOpen: boolean;
  onClose: () => void;
  children?: ReactNode;
  image?: Asset;
  editorUrl: string;
}

export const TemplateModal: FC<ITemplateModalProps> = ({ isOpen, onClose, image, editorUrl }) => {
  const { t } = useTranslation();

  const onEditorClick = () => {
    onClose();
    reportEditorClick({ origin: 'edit_modal' });
  };

  useEffect(() => {
    if (isOpen) {
      modalShown();
    }
  }, [isOpen]);

  return (
    <CustomModal isOpen={isOpen} onClose={onClose} className={s.TemplateModal__content}>
      <span className={s.TemplateModal__title}>{t('template-modal.title')}</span>
      <div
        className={s.TemplateModal__webContainer}
        style={image?.width && image?.height ? { aspectRatio: `${image?.width} / ${image?.height}` } : {}}
      >
        <div className={s.TemplateModal__webDotContainer}>
          <span className={s.TemplateModal__webDot} />
          <span className={s.TemplateModal__webDot} />
          <span className={s.TemplateModal__webDot} />
        </div>
        <img className={s.TemplateModal__img} src={image?.absoluteUrl} alt={image?.alt} />
      </div>
      <span className={s.TemplateModal__description}>{t('template-modal.description')}</span>
      <a target="_blank" href={editorUrl} onClick={onEditorClick} className={s.TemplateModal__btn} rel="noreferrer">
        {t('template-modal.btn')}
      </a>
    </CustomModal>
  );
};
